import CookieAPI from "shared/cookies";
import { getEnvironmentInfo, getRegistrationKey } from "shared/utils/config";
import { CONSENT_COOKIE_NAME, CONSENT_COOKIE_VERSION } from "shared/utils/constants";
import { AppType } from "shared/utils/enums";

export type ConsentType = {
  version?: number;
  necessary: boolean;
  functional: boolean;
  analytical: boolean;
  targeting: boolean;
};

export default class ConsentManagement {
  private static instance: ConsentManagement;
  private consentVersion: number = CONSENT_COOKIE_VERSION;
  private necessaryConsent: boolean;
  private functionalConsent: boolean;
  private analyticalConsent: boolean;
  private taragettingConsent: boolean;

  private constructor() {
    this.necessaryConsent = true;
    this.functionalConsent = false;
    this.analyticalConsent = false;
    this.taragettingConsent = false;

    // Load any existing consent from cookie
    let storedConsent = CookieAPI.getCookieObject(CONSENT_COOKIE_NAME);
    if (storedConsent && storedConsent.version === this.consentVersion) {
      this.necessaryConsent = storedConsent.necessary;
      this.functionalConsent = storedConsent.functional;
      this.analyticalConsent = storedConsent.analytical;
      this.taragettingConsent = storedConsent.targeting;
    } else {
      // If the version doesn't match, clear the old cookie
      CookieAPI.removeCookie(CONSENT_COOKIE_NAME);
    }
  }
  static getInstance(): ConsentManagement {
    if (!ConsentManagement.instance) {
      ConsentManagement.instance = new ConsentManagement();
    }
    return ConsentManagement.instance;
  }

  private saveConsent() {
    let consent = {
      version: this.consentVersion,
      necessary: this.necessaryConsent,
      functional: this.functionalConsent,
      analytical: this.analyticalConsent,
      targeting: this.taragettingConsent
    };
    // Save consent in a cookie for 365 days

    CookieAPI.setCookieObject(CONSENT_COOKIE_NAME, consent, 365);
  }
  grantConsent(consentType: ConsentType) {
    this.necessaryConsent = consentType.necessary;
    this.functionalConsent = consentType.functional;
    this.analyticalConsent = consentType.analytical;
    this.saveConsent();
  }

  hasAnalyticalConsent(): boolean {
    return this.analyticalConsent;
  }

  // // This is used to determine if the banner should be shown
  // initialBannerState(): boolean {
  //   return !this.analyticalConsent;
  // }

  static getConsentCopyKey(): string {
    const info = getEnvironmentInfo();
    if (info.appType === AppType.CONSOLE) {
      return "";
    }
    return getRegistrationKey();
  }

  revokeFullConsent() {
    this.necessaryConsent = true;
    this.functionalConsent = false;
    this.analyticalConsent = false;
    CookieAPI.removeAllCookies();
    this.saveConsent();
  }
  grantFullConsent() {
    this.necessaryConsent = true;
    this.functionalConsent = true;
    this.analyticalConsent = true;
    this.saveConsent();
  }

  hasConsentCookie(): boolean {
    return CookieAPI.getCookieObject(CONSENT_COOKIE_NAME) !== null;
  }
  getConsentStatus(): ConsentType {
    return {
      necessary: this.necessaryConsent,
      functional: this.functionalConsent,
      analytical: this.analyticalConsent,
      targeting: this.taragettingConsent,
      version: this.consentVersion
    };
  }
}

export const consentManagement = ConsentManagement.getInstance();
